import React, { useEffect, useRef } from "react";
import { useDrag } from "react-dnd";
import { WordSC } from "./styled";
import { IWord } from "../../../EditBox/types";
import { ItemType } from "../../../../index";

interface WordProps {
  word: { text: string; id: string };
  onClick: (word: IWord) => void;
}

export const Word: React.FC<WordProps> = ({ word, onClick }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  const [, dragRef] = useDrag({
    type: ItemType,
    item: { ...word },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  useEffect(() => {
    if (ref.current) {
      dragRef(ref);
    }
  }, [dragRef]);

  const addWord = () => {
    onClick({
      text: word.text,
      id: word.id,
    });
  };

  return (
    <WordSC ref={ref} onClick={addWord}>
      {word.text}
    </WordSC>
  );
};
